import { DeviceType, OSType } from '../themes/ge-base-p2p/constants'

export function detectDeviceType() {
    const userAgent = navigator.userAgent

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
        return DeviceType.mobile
    } else {
        return DeviceType.desktop
    }
}

export function detectMobileOperatingSystem() {
    const userAgent = navigator.userAgent

    if (/Android/i.test(userAgent)) {
        return OSType.android
    } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
        return OSType.ios
    } else {
        return OSType.unknown
    }
}

export function isMobile() {
    return detectDeviceType() === DeviceType.mobile
}

export function isDesktop() {
    return detectDeviceType() === DeviceType.desktop
}
